module.exports = __webpack_public_path__ + "img/clock-outline.f68aa086.svg";